// LanguageSelector.tsx
import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setLanguage } from 'Slices/LanguageSlice'
import { useGetLanguagesQuery } from 'Services/institution'

import {
  Select,
  FormControl,
  InputLabel,
  OutlinedInput,
  MenuItem,
} from '@mui/material'

export const LanguageSelector = () => {
  const dispatch = useDispatch()
  const language = useSelector((state: any) => state.language)
  const { locId, instId } = useSelector((state: any) => state.location)
  const { data, isSuccess } = useGetLanguagesQuery({ instId, locId })

  const handleLanguageChange = (event) => {
    dispatch(setLanguage(event.target.value))
  }

  useEffect(() => {
    data &&
      dispatch(
        setLanguage(
          data?.resources.some((lang) => lang.language === 'English')
            ? 'English'
            : data?.resources[0].language
        )
      )
  }, [isSuccess])

  return (
    <>
      <p tabIndex={0}>
        {`The descriptions for the tour experiences and audio guides are currently
        displayed in ${language}. Select another language option to experience the tour in a
        different language.`}
      </p>
      <FormControl size='small' sx={{ width: 300, mb: 3 }}>
        <InputLabel id='demo-multiple-name-label' htmlFor='demo-multiple-name'>Language</InputLabel>
        <Select
          labelId='demo-multiple-name-label'
          id='demo-multiple-name'
          value={language}
          onChange={handleLanguageChange}
          input={<OutlinedInput label='Language' />}
          inputProps={{ id: 'demo-multiple-name' }}
          sx={{ textTransform: 'capitalize' }}
        >
          {data?.resources.map((lang) => (
            <MenuItem key={lang.shortname} value={lang.language}>
              {lang.language}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  )
}

export default LanguageSelector
